import { InteractionSourceProps } from "./types";
import { Flex } from "@/components/atoms/flex";
import { useComponentStyle as useInteractionDetailsStyles } from "@/components/molecules/interactionWorkspace/controls/interactionDetails/style";
import { makeStyles, Text, mergeClasses } from "@fluentui/react-components";
import { DirectionArrow } from "@/components/atoms/directionArrow";

const useStyles = makeStyles({
	directionArrow: {
		marginRight: "2px",
	},
});

export const InteractionSource = (props: InteractionSourceProps) => {
	const interactionDetailsStyles = useInteractionDetailsStyles();
	const classes = useStyles();

	const showSecondary =
		!!props.secondaryInfo && props.mainInfo !== props.secondaryInfo;

	return (
		<Flex
			column
			className={mergeClasses(
				interactionDetailsStyles.interactionInfoContainer,
				interactionDetailsStyles.minWidthZero
			)}
		>
			<Text
				weight="bold"
				style={{ fontSize: "18px", lineHeight: "24px" }}
				className={interactionDetailsStyles.interactionInfo}
				title={props.mainInfo}
			>
				{props.mainInfo}
			</Text>
			<Text
				size={200}
				className={interactionDetailsStyles.interactionInfo}
				title={props.secondaryInfo}
			>
				{showSecondary && (
					<DirectionArrow
						direction={props.direction}
						className={classes.directionArrow}
					/>
				)}
				{showSecondary ? props.secondaryInfo : ""}
			</Text>
			<Text
				size={300}
				className={interactionDetailsStyles.interactionInfo}
				title={props.tertiaryInfo}
			>
				{props.tertiaryInfo}
			</Text>
		</Flex>
	);
};
